import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import * as _ from 'lodash';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'versements-libres-fees-form',
    templateUrl: './versements-libres-fees-form.component.html',
    styleUrls: ['./versements-libres-fees-form.component.scss'],
    standalone: false
})
export class VersementsLibresFeesFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  minFees: number = 0;
  maxFees: number = 100;

  ngOnInit(): void {
    this.subscriptionFacade.initForm(this);

    const pledge = this.subscriptionFacade.getPledge();

    this.initProductFeesValues(pledge);
  }

  initProductFeesValues(pledge: any) {
    const { operation } = pledge;

    this.productDao
      .getProduct(pledge?.products?.[0]?.productId as any)
      .subscribe(product => {
        if (
          operation === 'VERSEMENT_COMPLEMENTAIRE' &&
          !_.isNil(product.lifeInsuranceMinVersementLibreFrais)
        ) {
          this.minFees = this.floorValue(
            product.lifeInsuranceMinVersementLibreFrais * 100,
          );
          this.maxFees = this.floorValue(
            product.lifeInsuranceMaxVersementLibreFrais * 100,
          );
        }

        if (operation === 'VERSEMENT_PROGRAMME') {
          this.minFees = this.floorValue(
            product.lifeInsuranceMinProgrammedPaymentFee * 100,
          );
          this.maxFees = this.floorValue(
            product.lifeInsuranceMaxProgrammedPaymentFee * 100,
          );
        }

        if (!this.maxFees || this.maxFees < this.minFees)
          this.maxFees = this.minFees;

        if (
          this.products.get(`${0}`).get('parameters').get('versementFees')
            .value *
            100 <
          this.minFees
        )
          this.products
            .get(`${0}`)
            .get('parameters')
            .get('versementFees')
            .setValue(this.minFees);
      });
  }

  floorValue(value: number) {
    return Math.floor(value * 100) / 100;
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
